import type { Trophy, TrophyType } from "../lib/types";

// Trophy badge — rounded pill with emoji + label + optional season tag.
// Renders the four Fantasy Fams trophy types plus the auxiliary "beat the
// market" / "top decile streak" awards. Unknown types fall back to a generic
// "Trophy" label so future server-side trophy additions don't crash the UI.

const EMOJI: Record<TrophyType, string> = {
	weekly_winner: "🏆",
	quarter_champ: "🏅",
	earnings_king: "👑",
	duel_winner: "⚔️",
	beat_the_market: "📈",
	top_decile_streak: "🔥",
};

const LABEL: Record<TrophyType, string> = {
	weekly_winner: "Weekly Winner",
	quarter_champ: "Quarter Champ",
	earnings_king: "Earnings King",
	duel_winner: "Duel Winner",
	beat_the_market: "Beat the Market",
	top_decile_streak: "Top-10% Streak",
};

export function TrophyBadge({ trophy }: { trophy: Trophy }) {
	const emoji = EMOJI[trophy.type] ?? "🎖";
	const label = LABEL[trophy.type] ?? "Trophy";
	return (
		<span
			className="inline-flex items-center gap-1.5 rounded-full border border-[var(--color-accent)]/30 bg-[var(--color-accent-soft)] px-2.5 py-1 text-xs font-medium text-[var(--color-fg)]"
			title={trophy.season ?? undefined}
		>
			<span aria-hidden>{emoji}</span>
			<span>{label}</span>
			{trophy.season && (
				<span className="text-[var(--color-muted)]">· {trophy.season}</span>
			)}
		</span>
	);
}
